module.exports = __webpack_public_path__ + "static/media/displacement.059d1135.jpg";